export default (context, payload) => {
    const appState = context.rootState.appState;
    const moduleId = context.getters.moduleId;

    const selectedValue = context.rootState[payload.targetId].value;
    context.commit('setAttribute', {
        id: moduleId,
        attribute: 'showNotification',
        value: selectedValue === appState.yesNoOptions[0].value,
    }, {
        root: true,
    });
};